import { Phone, Mail, Facebook } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, FACEBOOK_URL } from "@/lib/data";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#070D18]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <img src="/images/logo.png" alt="Solubail — Financement d'équipements" className="h-9 w-auto rounded-md bg-white px-2.5 py-1 ring-1 ring-white/15" />
          <p className="text-sm text-slate-500 leading-relaxed mt-4 max-w-xs">
            Le partenaire d'équipement des PME québécoises. Crédit-bail, refinancement
            et fonds de roulement — sans la rigidité bancaire.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-sky-400">Navigation</p>
          <div className="mt-5 grid grid-cols-2 gap-3">
            {[
              ["Services", "services"],
              ["Équipements", "equipements"],
              ["Calculatrice", "calculatrice"],
              ["Pourquoi nous", "apropos"],
              ["Témoignages", "temoignages"],
              ["FAQ", "faq"],
            ].map(([label, id]) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToId(id)}
                className="text-left text-sm text-slate-400 hover:text-sky-400 transition-colors"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-sky-400">Contact</p>
          <div className="mt-5 space-y-3">
            <a data-testid="footer-phone-link" href={PHONE_TEL}
              className="flex items-center gap-3 text-sm text-slate-300 hover:text-sky-400 transition-colors">
              <Phone className="w-4 h-4 text-sky-400" /> {PHONE_DISPLAY}
            </a>
            <a data-testid="footer-email-link" href={`mailto:${EMAIL}`}
              className="flex items-center gap-3 text-sm text-slate-300 hover:text-sky-400 transition-colors break-all">
              <Mail className="w-4 h-4 text-sky-400 shrink-0" /> {EMAIL}
            </a>
            <a data-testid="footer-facebook-link" href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-3 text-sm text-slate-300 hover:text-sky-400 transition-colors">
              <Facebook className="w-4 h-4 text-sky-400" /> Suivez-nous sur Facebook
            </a>
          </div>
        </div>
      </div>
      <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3">
        <p className="text-xs text-slate-600">© 2026 Solubail — Soluco Financial Group. Tous droits réservés.</p>
        <div className="flex items-center gap-5">
          <a
            data-testid="footer-privacy-link"
            href="/confidentialite"
            className="text-xs text-slate-600 hover:text-sky-400 transition-colors"
          >
            Politique de confidentialité
          </a>
          <button
            data-testid="cookie-preferences-button"
            onClick={() => window.dispatchEvent(new Event("open-cookie-consent"))}
            className="text-xs text-slate-600 hover:text-sky-400 transition-colors"
          >
            Préférences de témoins
          </button>
          <p className="text-xs text-slate-600">Fièrement québécois. Montréal, QC.</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
